import type { TaskTimelineEntry } from '@erp/rpc';
export type OperatorEvent = Extract<
  TaskTimelineEntry,
  { kind: 'operator_step' }
>;
export type TimelineItem =
  | { kind: 'entry'; entry: TaskTimelineEntry }
  | { kind: 'operator_group'; entries: OperatorEvent[] };

/** Group only adjacent events from the same run and task; never reorder audit history. */
export function groupTimelineEvents(
  entries: TaskTimelineEntry[],
  view?: 'summary' | 'events',
): TimelineItem[] {
  const items: TimelineItem[] = [];
  for (const entry of entries) {
    if (view !== 'events' || entry.kind !== 'operator_step') {
      items.push({ kind: 'entry', entry });
      continue;
    }
    const previous = items.at(-1);
    if (
      previous?.kind === 'operator_group' &&
      previous.entries[0]?.agentRunId === entry.agentRunId &&
      previous.entries[0]?.taskId === entry.taskId
    ) {
      previous.entries.push(entry);
    } else items.push({ kind: 'operator_group', entries: [entry] });
  }
  return items;
}
